import * as React from "react";
import { SVGProps } from "react";

const Wallet: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={props.width || 40}
    height={props.height || 40}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.333 15.8667H9.33301C8.78634 15.8667 8.33301 15.4134 8.33301 14.8667C8.33301 14.32 8.78634 13.8667 9.33301 13.8667H17.333C17.8797 13.8667 18.333 14.32 18.333 14.8667C18.333 15.4134 17.8797 15.8667 17.333 15.8667Z"
      fill={props.fill || "#1A1C1F"}
    />
    <path
      d="M2.66699 15.8666C2.12033 15.8666 1.66699 15.4133 1.66699 14.8666V8.70662C1.66699 5.43996 4.32033 2.78662 7.587 2.78662H15.0803C18.507 2.78662 21.0003 5.06662 21.0003 8.19995C21.0003 8.74662 20.547 9.19995 20.0003 9.19995C19.4537 9.19995 19.0003 8.74662 19.0003 8.19995C19.0003 5.85328 16.9603 4.78662 15.0803 4.78662H7.587C5.427 4.78662 3.66699 6.54662 3.66699 8.70662V14.8666C3.66699 15.4266 3.21366 15.8666 2.66699 15.8666Z"
      fill={props.fill || "#1A1C1F"}
    />
    <path
      d="M21.3337 29.2002H8.00033C4.50699 29.2002 1.66699 26.3602 1.66699 22.8669V13.5335C1.66699 10.0402 4.50699 7.2002 8.00033 7.2002H21.3337C24.827 7.2002 27.667 10.0402 27.667 13.5335V15.4668C27.667 16.0135 27.2137 16.4668 26.667 16.4668H25.227C24.7603 16.4668 24.3337 16.6401 24.027 16.9601L24.0137 16.9735C23.5737 17.4135 23.4003 18.0268 23.5603 18.6268C23.7603 19.3735 24.547 19.9202 25.427 19.9202H26.667C27.2137 19.9202 27.667 20.3735 27.667 20.9202V22.8535C27.667 26.3602 24.827 29.2002 21.3337 29.2002ZM8.00033 9.2002C5.61366 9.2002 3.66699 11.1469 3.66699 13.5335V22.8669C3.66699 25.2535 5.61366 27.2002 8.00033 27.2002H21.3337C23.7203 27.2002 25.667 25.2535 25.667 22.8669V21.9335H25.427C23.627 21.9335 22.067 20.8002 21.627 19.1602C21.2803 17.8668 21.6537 16.4935 22.6003 15.5601C23.2937 14.8535 24.227 14.4668 25.227 14.4668H25.667V13.5335C25.667 11.1469 23.7203 9.2002 21.3337 9.2002H8.00033Z"
      fill={props.fill || "#1A1C1F"}
    />
    <path
      d="M27.9595 21.9335H25.3862C23.3729 21.9335 21.6662 20.4402 21.5062 18.5202C21.3996 17.4135 21.7996 16.3335 22.5996 15.5468C23.2662 14.8535 24.2129 14.4668 25.2129 14.4668H27.9462C29.2529 14.4668 30.3195 15.5202 30.3195 16.8268V19.5735C30.3329 20.8802 29.2662 21.9335 27.9595 21.9335ZM25.2262 16.4668C24.7595 16.4668 24.3329 16.6401 24.0262 16.9601C23.6396 17.3335 23.4529 17.8402 23.5062 18.3468C23.5729 19.2268 24.4262 19.9335 25.3862 19.9335H27.9595C28.1595 19.9335 28.3329 19.7735 28.3329 19.5735V16.8268C28.3329 16.6268 28.1595 16.4668 27.9595 16.4668H25.2262Z"
      fill={props.fill || "#1A1C1F"}
    />
  </svg>
);

export default Wallet;
